// 配置文件
const config = {
  // API基础URL
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL || 'https://dylz.mlkj.cc',
  // API_BASE_URL: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:18410',
  
  // 其他配置项
  APP_NAME: 'DYLZ Web',
  VERSION: '1.0.0',
  
  // 分页配置
  DEFAULT_PAGE_SIZE: 25,
  MAX_PAGE_SIZE: 100,
  
  // 文件上传配置
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/gif'],
  
  // 扩展下载配置
  EXTENSION_DOWNLOAD_URL: '/api/extension/download',
  
  // 角色配置
  ROLES: {
    ADMIN: 1,        // 管理员
    USER: 2,         // 用户
    EXTENSION: 3     // 扩展用户
  },
  
  // 角色名称映射
  ROLE_NAMES: {
    1: '管理员',
    2: '用户',
    3: '扩展用户'
  },
  
  // 本地存储键名
  STORAGE_KEYS: {
    USER_USERNAME: 'user_username',
    USER_NICKNAME: 'user_nickname',
    USER_ROLE: 'user_role',
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token'
  }
};

export default config; 